import { api, setAccessToken } from "./client";

export interface UserFamilyRef {
  family_id: string;
  role: string;
  joined_at: string;
}

export interface UserResponse {
  user_id: string;
  email: string;
  name: string;
  avatar_url: string | null;
  auth_provider: "apple" | "google" | "email";
  home_family_id: string;
  families: UserFamilyRef[];
  is_minor: boolean;
  guardian_user_id: string | null;
  ward_user_ids: string[];
  resolved_features: Record<string, boolean>;
  timezone: string | null;
  onboarding_complete: boolean;
}

export interface AuthResponse {
  access_token: string;
  user: UserResponse;
}

export interface AppleAuthPayload {
  identity_token: string;
  authorization_code: string;
  name?: string;
}

export const authApple = async (
  payload: AppleAuthPayload,
): Promise<AuthResponse> => {
  const { data } = await api.post<AuthResponse>("/auth/apple", payload);
  setAccessToken(data.access_token);
  return data;
};

export const authMe = async (): Promise<UserResponse> => {
  const { data } = await api.get<UserResponse>("/auth/me");
  return data;
};

export const authLogout = async (): Promise<void> => {
  try {
    await api.post("/auth/logout");
  } finally {
    setAccessToken(null);
  }
};
